/**
 * Clerk **`publishableKey`** only when it looks real. Placeholder values from **`.env.example`**
 * (**`pk_test_...`**) cause **`ClerkProvider`** to throw → blank screen.
 */
export function resolveClerkPublishableKey(): string | undefined {
  const raw = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY?.trim();
  if (!raw) return undefined;
  if (!raw.startsWith("pk_test_") && !raw.startsWith("pk_live_")) return undefined;
  if (raw.endsWith("...")) return undefined;
  if (raw.length < 32) return undefined;
  return raw;
}
